import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
var Hammer = require("ng-hammerjs");

class PdfViewer {
    constructor() {
        pdfjsLib.GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.js';
        this.pdfObject;
        this.viewport;
        this.globalScale = 1;
        this.minScale = 0;
        this.maxScale = 3.5;
        this.isWorking = false;
        this.is_touch_device = 'ontouchstart' in document.documentElement;
    }
    getPage(pageNumber, scale, callback) {
        var self = this;
        if (!self.isWorking) {
            self.isWorking = true;
            self.pdfObject.getPage(pageNumber).then(function (page) {
                self.viewport = page.getViewport({ scale: 1.0 });
                var scaleValueHeight = (document.getElementById("md-zoom-container").clientHeight - document.getElementsByClassName("toolbar")[0].clientHeight) / self.viewport.height;
                var scaleValueWidth = document.getElementById("md-zoom-container").clientWidth / self.viewport.width;
                var scaleValue = scaleValueHeight < scaleValueWidth ? scaleValueHeight : scaleValueWidth;
                if (scale === undefined) {
                    self.minScale = scaleValue;
                    if (self.globalScale === 1) {
                        self.globalScale = scaleValue;
                    }
                }
                else {
                    self.globalScale = scale * self.globalScale;
                    if (self.globalScale > self.maxScale) {
                        self.globalScale = self.maxScale;
                    }
                    if (self.globalScale < self.minScale) {
                        self.globalScale = self.minScale;
                    }
                }
                self.viewport = page.getViewport({ scale: self.globalScale });

                // Prepare canvas using PDF page dimensions
                var canvas = document.getElementById('the-canvas');
                var context = canvas.getContext('2d');
                canvas.height = self.viewport.height;
                canvas.width = self.viewport.width;

                // Render PDF page into canvas context
                var renderContext = {
                    canvasContext: context,
                    viewport: self.viewport
                };
                var renderTask = page.render(renderContext);
                renderTask.promise.then(function () {
                    self.isWorking = false;
                    if (callback !== undefined) {
                        callback();
                    }
                });
            });
        }

    }
    loadPdf(url, callback) {
        var self = this;
        var loadingTask = pdfjsLib.getDocument(url);
        loadingTask.promise.then(function (pdf) {
            self.pdfObject = pdf;

            // Fetch the first page
            var pageNumber = 1;
            self.getPage(pageNumber, undefined, function () {
                var myElement = document.getElementById('the-canvas');
                self.hammerIt(myElement);
                if (callback)
                    callback();
            });
        }, function (reason) {
            // PDF loading error
            console.error(reason);
        });
    }
    hammerIt(elm) {
        var self = this;
        if (self.is_touch_device) {
            var hammertime = new Hammer(elm, {});
            hammertime.get('pinch').set({
                enable: true
            });
            var posX = 0,
                posY = 0,
                scale = 1,
                last_scale = 1,
                last_tempScale = 0,
                pinchActive = false,
                last_posX = 0,
                last_posY = 0,
                max_pos_x1 = 0,
                max_pos_y1 = 0,
                max_pos_x2 = 0,
                max_pos_y2 = 0,
                transform = "",
                disabled = false,
                el = elm;

            hammertime.on('pan pinch panend pinchend', function (ev) {
                if (!disabled) {
                    //pan
                    if (ev.type === "pan" && !pinchActive) {
                        posX = last_posX + ev.deltaX;
                        posY = last_posY + ev.deltaY;
                        var elementWidth = el.clientWidth;
                        var elementHeight = el.clientHeight;
                        max_pos_x1 = 0;
                        max_pos_y1 = 0;
                        max_pos_x2 = elementWidth > window.innerWidth ? -(elementWidth - window.innerWidth) : 0;
                        max_pos_y2 = elementHeight > window.innerHeight ? -(elementHeight - window.innerHeight + 120) : 0;
                        if (posX > max_pos_x1) {
                            posX = max_pos_x1;
                        }
                        if (posX < max_pos_x2) {
                            posX = max_pos_x2;
                        }
                        if (posY > max_pos_y1) {
                            posY = max_pos_y1;
                        }
                        if (posY < max_pos_y2) {
                            posY = max_pos_y2;
                        }
                    }
                    //panend
                    if (ev.type === "panend" && !pinchActive) {
                        if (posX > max_pos_x1) {
                            last_posX = max_pos_x1;
                        }
                        else if (posX < max_pos_x2) {
                            last_posX = max_pos_x2;
                        }
                        else {
                            last_posX = posX;
                        }
                        if (posY > max_pos_y1) {
                            last_posY = max_pos_y1;
                        }
                        else if (posY < max_pos_y2) {
                            last_posY = max_pos_y2;
                        }
                        else {
                            last_posY = posY;
                        }
                    }

                    //pinch
                    if (ev.type === "pinch") {
                        pinchActive = true;
                        scale = last_scale * ev.scale;
                        if (scale < 1 && self.globalScale * scale < self.minScale) {
                            scale = last_tempScale;
                        }
                        if (scale > 1 && self.globalScale * scale > self.maxScale) {
                            scale = last_tempScale;
                        }
                        last_tempScale = scale;
                    }
                    if (ev.type === "pinchend") {
                        disabled = true;
                        var clientWidth = el.scrollWidth;
                        var clientHeight = el.scrollHeight;

                        self.getPage(1, scale, function () {
                            posX = -((scale - 1) * clientWidth / 2 - last_posX);
                            posY = -((scale - 1) * clientHeight / 2 - last_posY);
                            var elementWidth = el.clientWidth;
                            var elementHeight = el.clientHeight;
                            max_pos_x1 = 0;
                            max_pos_y1 = 0;
                            max_pos_x2 = elementWidth > window.innerWidth ? -(elementWidth - window.innerWidth) : 0;
                            max_pos_y2 = elementHeight > window.innerHeight ? -(elementHeight - window.innerHeight) : 0;
                            if (posX > max_pos_x1) {
                                posX = max_pos_x1;
                            }
                            if (posX < max_pos_x2) {
                                posX = max_pos_x2;
                            }
                            if (posY > max_pos_y1) {
                                posY = max_pos_y1;
                            }
                            if (posY < max_pos_y2) {
                                posY = max_pos_y2;
                            }
                            transform =
                                "translate(" + posX + "px," + posY + "px) " +
                                "scale(1,1)";
                            el.style.webkitTransform = transform;
                            pinchActive = false;
                            last_posX = posX;
                            last_posY = posY;
                            scale = 1;
                            last_scale = 1;
                            transform = "";
                            disabled = false;
                        });
                        last_scale = scale;
                    }

                    if (ev.type !== "pinchend") {
                        transform =
                            "translate(" + posX + "px," + posY + "px) " +
                            "scale(" + scale + ", " + scale + ")";
                    }

                    if (transform) {
                        el.style.webkitTransform = transform;
                    }
                }
            });
        }
    }
}

export { PdfViewer }